import { render, staticRenderFns } from "./ListPreferred.vue?vue&type=template&id=0b843ab1"
import script from "./ListPreferred.vue?vue&type=script&lang=js"
export * from "./ListPreferred.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports